import $ from 'jquery';
import Track from 'utils/track';
import { Message } from 'element-ui';
import { copy } from 'utils/Clipboard';

// 格式化时间为年月日时分秒
const formatDateTime = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export default {
  track: {
    inserted: async (el, binding) => {
      let $el = $(el);
      let value = binding.value;
      let method = value?.method || 'click';
      let event = value?.event || 'default_track';
      $el.on(method, async function() {
        const track = new Track();
        await track.track({
          method,
          event
        });
      });
    }
  },
  copy: {
    bind(el, binding) {
      el.style.cursor = 'pointer';
      el.title = '点击复制';
      el.addEventListener('click', async () => {
        const textToCopy = binding.value || el.textContent || el.innerText;
        try {
          await copy(textToCopy);
          Message.success('复制成功');
        } catch (err) {
          Message.error('复制失败，请手动复制');
        }
      });
    },
    unbind(el) {
      el.removeEventListener('click', el._copyHandler);
    }
  },
  viewportTrack: {
    inserted: (el, binding) => {
      const track = new Track();
      const value = binding.value;
      const event = value?.event || 'default_viewport_track';
      const payload = value?.payload || {};
      let startTime = null;
      let enterTime = null; // 记录进入时间
      let inViewport = false;
      let delayedStartTime = null;
      let stayTime = 0;

      // 保存50秒计时上限的定时器
      let maxTimeTimer = null;

      // 创建IntersectionObserver来监测元素是否在视口中
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            console.log(`${event} 进入视口`);
            // 元素进入视口
            inViewport = true;
            // 记录进入时间
            enterTime = new Date();
            // 3秒后开始计时
            delayedStartTime = setTimeout(() => {
              console.log(`${event} 开始计时`);
              startTime = Date.now();

              // 设置50秒计时上限定时器
              maxTimeTimer = setTimeout(() => {
                console.log(`${event} 达到50秒上限，自动上报`);
                // 上报50秒停留时间
                const stayTime = 50;
                const endTime = new Date();
                // 合并payload数据
                const reportPayload = {
                  ...payload,
                  stay_time: stayTime,
                  enter_time: formatDateTime(enterTime),
                  end_time: formatDateTime(endTime)
                };
                track.track({
                  event,
                  payload: reportPayload
                });
                // 停止计时
                startTime = null;
                if (maxTimeTimer) {
                  clearTimeout(maxTimeTimer);
                  maxTimeTimer = null;
                }
              }, 50000);
            }, 3000);
          } else {
            console.log(`${event} 离开视口`);
            // 元素离开视口
            inViewport = false;
            // 清除所有定时器
            if (delayedStartTime) {
              clearTimeout(delayedStartTime);
              delayedStartTime = null;
            }
            if (maxTimeTimer) {
              clearTimeout(maxTimeTimer);
              maxTimeTimer = null;
            }
            // 如果已经开始计时，计算停留时间并上报
            if (startTime) {
              stayTime = Math.floor((Date.now() - startTime) / 1000);
              if (stayTime > 0) {
                console.log(`${event} 停留时间 ${stayTime} 秒`);
                const endTime = new Date();
                // 合并payload数据
                const reportPayload = {
                  ...payload,
                  stay_time: stayTime,
                  enter_time: formatDateTime(enterTime),
                  end_time: formatDateTime(endTime)
                };
                track.track({
                  event,
                  payload: reportPayload
                });
              }
              startTime = null;
              stayTime = 0;
              enterTime = null;
            }
          }
        });
      }, {
        // 只要元素有部分进入视口就触发
        threshold: 0
      });

      // 观察元素
      observer.observe(el);

      // 保存observer和相关数据到元素上，以便unbind时清理
      el._viewportObserver = observer;
      el._viewportTrackData = {
        startTime,
        enterTime,
        inViewport,
        delayedStartTime,
        stayTime,
        track,
        event,
        payload,
        maxTimeTimer
      };
    },
    unbind: (el) => {
      // 清理IntersectionObserver
      if (el._viewportObserver) {
        el._viewportObserver.disconnect();
        el._viewportObserver = null;
      }

      // 清理计时器
      if (el._viewportTrackData?.delayedStartTime) {
        clearTimeout(el._viewportTrackData.delayedStartTime);
      }
      // 清理50秒计时上限定时器
      if (el._viewportTrackData?.maxTimeTimer) {
        clearTimeout(el._viewportTrackData.maxTimeTimer);
      }

      // 如果元素仍在视口中，上报停留时间
      if (el._viewportTrackData?.inViewport && el._viewportTrackData?.startTime) {
        const stayTime = Math.floor((Date.now() - el._viewportTrackData.startTime) / 1000);
        // 设置计时上限为50秒
        const cappedStayTime = Math.min(stayTime, 50);
        if (cappedStayTime > 0) {
          const endTime = new Date();
          // 合并payload数据
          const reportPayload = {
            ...(el._viewportTrackData.payload || {}),
            stay_time: cappedStayTime,
            enter_time: el._viewportTrackData.enterTime ? formatDateTime(el._viewportTrackData.enterTime) : '',
            end_time: formatDateTime(endTime)
          };
          el._viewportTrackData.track.track({
            event: el._viewportTrackData.event,
            payload: reportPayload
          });
        }
      }

      // 清理数据
      el._viewportTrackData = null;
    }
  }
};
